<template>
<div class="start_page_box">
    <div class="wrap" style="height:100vh">
        <dl>
            <dt>회원가입 완료!</dt>
            <dd>
                {{auth.name}}님 반갑습니다.<br>
                지금 바로 쇼룸 방문 예약을 시작해 보세요.
            </dd>
        </dl>
        <span>
            
        </span>
        <button @click="$router.replace('/main')">시작하기</button>
    </div>
</div>

<!-- <div>
    <div class="finish_join">
        <div class="wrap">
            <dl>
                <dt>회원 가입 완료</dt>
                <dd>
                    프리북 고객이 되신것을 환영합니다.
                </dd>
            </dl>
            <div>
                <p>
                    나만을 위해 준비된<br>프리미엄 상담 예약 서비스
                </p>
                <img :src="$store.state.resource.imgPreebookLogoW">
            </div>
            
        </div>
    </div>

    <div class="btn_box_fixed">
        <router-link to="/main" class="default_btn1">프리북 시작하기</router-link>
    </div> 
</div> -->
   

</template>

<script>

export default {
    name:'JoinComplete',
    beforeRouteLeave(to, from, next) {
        if(to.name == 'JoinSocial')
            return next('/main');

        return next();
    },
    created () {
        this.$store.state.header = false;
        this.$store.state.headerBlank = false;
        this.$store.commit('SHOW_ONLOAD');
    },
    computed: {},
    methods: {},
}
</script>

<style lang="scss" scoped>

</style>